module.exports = __webpack_public_path__ + "static/media/peru_icon.8958e1bd.png";